import { render, staticRenderFns } from "./Activate.vue?vue&type=template&id=38f9206e&scoped=true&"
import script from "./Activate.vue?vue&type=script&lang=js&"
export * from "./Activate.vue?vue&type=script&lang=js&"
import style0 from "./Activate.vue?vue&type=style&index=0&id=38f9206e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../data/code/fc/dpp/dppofficialwebsitev2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f9206e",
  null
  
)

export default component.exports